import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { AssetsStore, StoreName, getLocalStorageKeyForStore, isRestrictedEmail } from '@coach-bot/data-access/shared';
import {
  EXTENSION_ICONS,
  EXTENSION_NAME_LEARN_AND_EARN_FRIENDLY,
  EXTENSION_NAME_LEARN_WITH_AI_FRIENDLY,
} from '@shared/extension/constants';
import { getRawTranslation } from '@shared/translate/utils/get-raw-translation';
import { AbstractComponent } from '@shared/ui';
import { BehaviorSubject } from 'rxjs';
import { getLocalStorage } from '../../../../../../../../extension/service-worker/utils/local-storage';

const PROFILE_EMAIL_LOCAL_STORAGE_KEY: string = getLocalStorageKeyForStore(
  'profileEmail',
  StoreName.ServiceWorkerCommonStore
);

@Component({
  selector: 'da-inactive',
  templateUrl: './inactive.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InactiveComponent extends AbstractComponent implements OnInit {
  readonly assetsPath$: BehaviorSubject<string> = this.assetsStore.assetsPath$;

  description: string;
  icon: string;
  title: string;

  constructor(
    private assetsStore: AssetsStore,
    private changeDetectorRef: ChangeDetectorRef
  ) {
    super();
  }

  async ngOnInit(): Promise<void> {
    const email: string = await getLocalStorage(PROFILE_EMAIL_LOCAL_STORAGE_KEY);
    const isUserRestricted: boolean = isRestrictedEmail(email);
    const name: string = isUserRestricted
      ? EXTENSION_NAME_LEARN_WITH_AI_FRIENDLY
      : EXTENSION_NAME_LEARN_AND_EARN_FRIENDLY;
    getRawTranslation('dashboard.inactive.labels.description').then((description: string) => {
      this.description = description;
      this.icon = isUserRestricted ? EXTENSION_ICONS.LEARN_WITH_AI.DEFAULT : EXTENSION_ICONS.LEARN_AND_EARN.DEFAULT;
      this.title = name;
      this.changeDetectorRef.detectChanges();
    });
  }
}
